import { EmojiSad } from "iconoir-react";

export function WordNotFound() {
  return (
    <div className="my-24 w-full flex flex-col space-y-3 items-center">
      <EmojiSad
        height={50}
        width={50}
        className="stroke-2 text-brand-purple"
      />
      <h5 className="text-lg font-bold pt-4">No Definitions Found</h5>
      <p className="text-center text-gray-500 dark:text-gray-300">Sorry pal, we couldn't find definitions for the word you were looking for. You can try the search again at later time or head to the web instead.</p>
    </div>
  );
}